import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { FC } from "react";

interface FilterChipActionButtonsProps {
  onClear?: () => void;
  onCancel?: () => void;
  onApply?: () => void;

  disableClearButton?: boolean;
  disableCancelButton?: boolean;
  disableApplyButton?: boolean;
  id?: string;
}

export const FilterChipActionButtons: FC<FilterChipActionButtonsProps> = ({
  onClear,
  onCancel,
  onApply,
  disableClearButton,
  disableCancelButton,
  disableApplyButton,
  id = "filter-chip-actions",
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" id={id}>
      <Button
        id={`${id}-clear-btn`}
        data-testid="filter-clear-btn"
        variant="text"
        color="inherit"
        size="small"
        onClick={onClear}
        disabled={disableClearButton}
      >
        Clear
      </Button>
      <Stack direction="row" spacing={1}>
        <Button
          id={`${id}-cancel-btn`}
          data-testid="filter-cancel-btn"
          variant="text"
          size="small"
          color="inherit"
          onClick={onCancel}
          disabled={disableCancelButton}
        >
          Cancel
        </Button>
        <Button
          id={`${id}-apply-btn`}
          data-testid="filter-apply-btn"
          variant="text"
          color="primary"
          size="small"
          onClick={onApply}
          disabled={disableApplyButton}
        >
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
